import { downgradeComponent } from '@angular/upgrade/static';
import { SsoProviderButtonComponent } from './sso-provider-button.component';
import angular from 'angular';

export const ngxSsoProviderButtonModule = angular.module('ngxSsoProviderButton', [])
	.directive('ngxSsoProviderButton', downgradeComponent({component: SsoProviderButtonComponent})).name;
